import React, { useEffect, useState } from "react";
import Drawer from "../Drawer";
import { Type, X } from "lucide-react";
import { TailSpin } from "react-loader-spinner";
import Select from "react-select";

const PageTags = ({
    show,
    toggle,
    loader,
    option,
    editTags,
    updateTags,
}) => {

    const [tags, setTags] = useState<any>([]);

    useEffect(() => {
        setTags(editTags?.tags);
    }, [editTags]);

    const handleTagChange = (event: any) => {
        let newTags = [...event.map((item: any) => item.value)];
        setTags(newTags);
    };

    return (
        <Drawer
            show={show}
            onHide={toggle}
            id="drawerEnd"
            drawer-end="true"
            className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-[1050] dark:bg-zink-600"
        >
            <Drawer.Header
                className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
                closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
            >
                <Drawer.Title className="text-15">
                    {"Edit Tags"}
                </Drawer.Title>
                <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
            </Drawer.Header>
            <Drawer.Body className="h-full p-4 overflow-y-auto">
                <div>
                    <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                        <div className="xl:col-span-12">
                            <label
                                htmlFor="phoneNumberInput"
                                className="inline-block mb-2 text-base font-medium"
                            >
                                Tags
                            </label>
                            <Select
                                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                options={option}
                                isSearchable={true}
                                value={tags?.map((item) => ({
                                    label: item,
                                    value: item,
                                }))}
                                isClearable={true}
                                isMulti={true}
                                onChange={(event: any) => handleTagChange(event)}
                                id="choices-single-default3"
                            />
                        </div>
                    </div>
                </div>
                <div className="flex justify-end gap-2 mt-4">
                    <button
                        type="reset"
                        id="close-modal"
                        data-modal-close="addEmployeeModal"
                        className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                        onClick={toggle}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => updateTags(editTags, tags)}
                        type="submit"
                        disabled={loader}
                        style={{
                            minWidth: "130px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                        id="addNew"
                        className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                        {loader ? "Updating..." : "Update"}
                    </button>
                </div>
            </Drawer.Body>
        </Drawer>
    );
};

export default PageTags;